module.exports = ".mat-dialog-content {\r\n  margin: 0 !important\r\n}\r\n"